<header #header [enableImpersonation]="false" brandImage="../../assets/common/header/logo-randstad.png"
    brandImageAlt="Randstad">

    <dashboard-menu menuSection [hidden]="!showKpis"
        [selectedOfficeIsRecruitment]="selectedOfficeIsRecruitment"></dashboard-menu>
    <dashboard-mobile-menu mobileMenuSection [hidden]="!showKpis"
        (onOptionSelected)="header.showMobileMenu=false"></dashboard-mobile-menu>
    <launcher-mobile mobileMenuSection></launcher-mobile>
    <office-selector userActions></office-selector>
    <div userActions style="display: flex; flex-direction: row; flex-wrap: nowrap; justify-content: flex-end;">
      @if (impersonationEnabled) {
        <impersonation-menu></impersonation-menu>
      }
      <help [compactView]="impersonationEnabled"></help>
    </div>
</header>
<loading-overlay [show]="busy">
    <div class="container-fluid rs-container">

        <div class="row">
            <launcher></launcher>

            <div class="col-12 col-md-12 col-lg-12 col-xl-12 bd-content" style="max-width: 100%;" [hidden]="showKpis">
                <h1 style="font-size: 24px; font-weight: 500; text-align: center;">
                    No existen indicadores que mostrar para esta oficina
                </h1>
            </div>

            <div class="col-12 col-md-12 col-lg-12 col-xl-12 bd-content" [hidden]="!showKpis">

                <kpi-group #overviewBucketGroup [title]="'Situación de tus bucket'" [subtitle]="dashboardOwner">

                    <kpi-group-row>

                        <!-- GRAFICO DE PORCENTAJE -->
                         @if (callToActionBucketPercentageHostVisible) {
                            <kpi-host #callToActionAHost
                            [title]="'Porcentaje bucket'" [refreshing]="bucketAStatusDetailServiceHost.loading"
                            [warn]="bucketAStatusDetailServiceHost.warn"
                            [lastUpdatedText]="bucketAStatusDetailServiceHost.lastUpdatedText" [size]="2"
                            [hostsDoughnutChart]="true">

                            <i icon class="material-icons">people</i>

                            <kpi-host-menu-option menuOption [text]="'Actualizar'"
                                (click)="bucketAStatusDetailServiceHost.refresh()"></kpi-host-menu-option>

                            <bucket-percentage-extended-kpi-service-host sink #bucketAStatusDetailServiceHost>
                            </bucket-percentage-extended-kpi-service-host>

                            <ng-container additionalData>
                              @if (!bucketAStatusDetailServiceHost.summaryData && !bucketAStatusDetailServiceHost.summaryError) {
                                <div style="width: 100%; height: 100%; display: flex; flex-direction: row; align-items:center; flex-wrap: nowrap;">
                                    <p style="margin-left:auto;">{{textAction}}</p><i class="far fa-thumbs-up"
                                        style="margin-left: 5px; margin-right: auto;"></i>
                                </div>
                              }

                              @if (bucketAStatusDetailServiceHost.summaryData) {
                                <doughnut-chart style="max-width: 480px;" #bucketAStatusDetailChart
                                    [data]="bucketAStatusDetailServiceHost.summaryData.buckets" [isVisible]="true"
                                    [isPercentage]="bucketAStatusDetailServiceHost.summaryData.isPercentage"
                                    [colorPalette]="bucketAStatusDetailServiceHost.summaryData.colorPalette"
                                    [totalStyle]="bucketAStatusDetailServiceHost.summaryData.total == 0 ? bucketAStatusDetailChart.dataValueStyle.Zero : bucketAStatusDetailChart.dataValueStyle.Warn">
                                </doughnut-chart>
                              }
                            </ng-container>

                            @if (bucketAStatusDetailServiceHost.summaryData) {
                              <i additionalData class="icon icon-home"></i>
                            }

                            @if (bucketAStatusDetailServiceHost.summaryError) {
                              <data-error errorMsg
                                [errorMessage]="bucketAStatusDetailServiceHost.summaryError.message"
                                (onRequestRefresh)="bucketAStatusDetailServiceHost.refresh()">
                              </data-error>
                            }
                          </kpi-host>
                         }

                        <!-- GRAFICO DE TOTALES -->
                         @if (callToActionBucketFillOutHostVisible) {
                            <kpi-host #callToActionBHost
                            [title]="'Necesitas rellenar'" [refreshing]="bucketBStatusDetailServiceHost.loading"
                            [warn]="bucketBStatusDetailServiceHost.warn"
                            [lastUpdatedText]="bucketBStatusDetailServiceHost.lastUpdatedText" [size]="2"
                            [hostsDoughnutChart]="true">

                            <i icon class="material-icons">people</i>

                            <kpi-host-menu-option menuOption [text]="'Actualizar'"
                                (click)="bucketBStatusDetailServiceHost.refresh()"></kpi-host-menu-option>

                            <bucket-fill-out-extended-kpi-service-host sink #bucketBStatusDetailServiceHost>
                            </bucket-fill-out-extended-kpi-service-host>

                            <ng-container additionalData>
                              @if (!bucketBStatusDetailServiceHost.summaryData && !bucketBStatusDetailServiceHost.summaryError) {
                                <div style="width: 100%; height: 100%; display: flex; flex-direction: row; align-items:center; flex-wrap: nowrap;">
                                    <p style="margin-left:auto;">¡Buen trabajo!</p><i class="far fa-thumbs-up"
                                        style="margin-left: 5px; margin-right: auto;"></i>
                                </div>
                              }

                              @if (bucketBStatusDetailServiceHost.summaryData) {
                                <doughnut-chart style="max-width: 480px;" #bucketBStatusDetailChart
                                  [data]="bucketBStatusDetailServiceHost.summaryData.buckets" [isVisible]="true"
                                  [colorPalette]="bucketBStatusDetailServiceHost.summaryData.colorPalette"
                                  [totalStyle]="bucketBStatusDetailServiceHost.summaryData.total == 0 ? bucketBStatusDetailChart.dataValueStyle.Zero : bucketBStatusDetailChart.dataValueStyle.Warn">
                                </doughnut-chart>
                              }
                            </ng-container>

                            @if (bucketBStatusDetailServiceHost.summaryData) {
                              <i additionalData class="icon icon-home"></i>
                            }

                            @if (bucketBStatusDetailServiceHost.summaryError) {
                              <data-error errorMsg
                                [errorMessage]="bucketBStatusDetailServiceHost.summaryError.message"
                                (onRequestRefresh)="bucketBStatusDetailServiceHost.refresh()">
                              </data-error>
                            }
                          </kpi-host>
                         }

                    </kpi-group-row>

                    <kpi-group-row>

                        <!-- TABLA DE DATOS DE BUCKETS -->
                         @if (callToActionPriorityHostVisible) {
                          <div>
                            <bucket-priority></bucket-priority>
                          </div>
                         }

                    </kpi-group-row>

                </kpi-group>

            </div>

        </div>
    </div>
</loading-overlay>
